import React, { useEffect, useState } from 'react';
import { getForms } from '../../../actions/formActions';
import { getConfiguration } from '../../../actions/configurationActions';
import { applyStrategy } from '../../../actions/strategyActions';
import { useSelector, useDispatch } from 'react-redux';
import SearchBoxWithListing from '../../Common/SearchBoxWithListing';
import lodash from 'lodash'
import { FaPlus } from 'react-icons/fa'; // Importing the plus icon
import { configToStrategy, strategyToConfig } from '../../../utils/utility';
import ChartView from './ChartView';

const StrategyAnalysis = (props) => {

    const searchBoxKey = "strategy_search_form";
    const listFormKey = "strategy_list_form";
    const dispatch = useDispatch();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const userState = useSelector((state) => state.user);
    const formState = useSelector((state) => state.forms);
    const strategyState = useSelector((state) => state.strategy);
    const configurationState = useSelector((state) => state.configuration);
    const { configuration = {} } = configurationState;
    const { listing = {}, strategyData = {}, metaData = {} } = strategyState;
    const { data: listData = [] } = listing;
    const { formJson = {} } = formState;
    const searchBoxJson = formJson[searchBoxKey] || {};
    const { data = {} } = searchBoxJson;
    const { section = [] } = data;
    const [firstSection = {}] = section;
    const { fields = [] } = firstSection;
    const addIconField = fields.filter(field => field.id == 'addIcon');
    const showAddIcon = addIconField.length > 0;
    const [{ label = '' } = {}] = addIconField;
    const [loading, setLoading] = useState(true);
    const [updatedSearchBoxValues, setUpdatedSearchBoxValues] = useState({});

    const actionsHandling = (action, rowData) => {
        console.log("Action = ", action, rowData);
    }

    const listApi = (data, requestConfig = {}) => {
        const configData = strategyToConfig(data);
        return dispatch(applyStrategy(configData, listFormKey, requestConfig));
    }

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get('id'); // Get the value of 'r'
        if (id != null) {
            dispatch(getConfiguration({ id }));
        }
        else {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        // console.log("StrategyAnalysis-useEffect[configuration]", configuration);
        if (lodash.isEmpty(configuration))
            return;
        // setLoading(true);
        const data = configToStrategy(configuration);
        setUpdatedSearchBoxValues(data);
        setLoading(false);
    }, [configuration]);

    const handleAdd = () => {
        alert('Yet to implement');
        setIsModalOpen(true);
    }

    return (
        <div style={{ position: 'relative', paddingBottom: showAddIcon ? '80px' : '0px' }}> {/* Added padding-bottom */}
            {loading ? <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div> :
                <>
                    <SearchBoxWithListing
                        searchBoxKey={searchBoxKey}
                        listFormKey={listFormKey}
                        fetchForm={getForms}
                        listApi={listApi}
                        searchBoxJson={searchBoxJson}
                        listingData={listing}
                        actionsHandling={actionsHandling}
                        updatedSearchBoxValues={updatedSearchBoxValues}
                        componentsInMiddle={listData.length ? <ChartView strategyData={strategyData} listing={listing} metaData={metaData} /> : ''}
                    />

                    {/* Floating Add Button */}
                    {showAddIcon ? <div
                        onClick={() => handleAdd()}
                        style={{
                            position: 'fixed',
                            bottom: '20px',
                            right: '20px',
                            backgroundColor: 'green',
                            color: 'white',
                            borderRadius: '50%',
                            padding: '15px',
                            cursor: 'pointer',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            zIndex: 1000,
                        }}
                        title={label}
                    >
                        <FaPlus size={20} />
                    </div> : ''}
                </>
            }
        </div>
    );
};

export default StrategyAnalysis;
